/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Core_Benefits_And_Highlights_BuInputs */

const en_core_benefits_and_highlights_bu = /** @type {(inputs: Core_Benefits_And_Highlights_BuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Core Benefits & Highlights (Bullet Points)`)
};

const es_core_benefits_and_highlights_bu = /** @type {(inputs: Core_Benefits_And_Highlights_BuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beneficios clave y aspectos destacados (Viñetas)`)
};

const fr_core_benefits_and_highlights_bu = /** @type {(inputs: Core_Benefits_And_Highlights_BuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avantages clés & Points forts (Puces)`)
};

const de_core_benefits_and_highlights_bu = /** @type {(inputs: Core_Benefits_And_Highlights_BuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kernvorteile & Highlights (Aufzählungspunkte)`)
};

const ja_core_benefits_and_highlights_bu = /** @type {(inputs: Core_Benefits_And_Highlights_BuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主なメリットと特徴 (箇条書き)`)
};

const zh_core_benefits_and_highlights_bu = /** @type {(inputs: Core_Benefits_And_Highlights_BuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核心优势与亮点 (要点形式)`)
};

const ar_core_benefits_and_highlights_bu = /** @type {(inputs: Core_Benefits_And_Highlights_BuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفوائد الأساسية والمزايا (نقاط)`)
};

const id_core_benefits_and_highlights_bu = /** @type {(inputs: Core_Benefits_And_Highlights_BuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manfaat & Sorotan Utama (Poin-poin)`)
};

const it_core_benefits_and_highlights_bu = /** @type {(inputs: Core_Benefits_And_Highlights_BuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vantaggi Principali & Punti di Forza (Punti Elenco)`)
};

const ru_core_benefits_and_highlights_bu = /** @type {(inputs: Core_Benefits_And_Highlights_BuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основные преимущества и особенности (пункты)`)
};

const pt_core_benefits_and_highlights_bu = /** @type {(inputs: Core_Benefits_And_Highlights_BuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benefícios Principais e Destaques (Lista)`)
};

const ko_core_benefits_and_highlights_bu = /** @type {(inputs: Core_Benefits_And_Highlights_BuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`핵심 혜택 및 주요 특징 (글머리 기호)`)
};

/**
* | output |
* | --- |
* | "Core Benefits & Highlights (Bullet Points)" |
*
* @param {Core_Benefits_And_Highlights_BuInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const core_benefits_and_highlights_bu = /** @type {((inputs?: Core_Benefits_And_Highlights_BuInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Core_Benefits_And_Highlights_BuInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_core_benefits_and_highlights_bu(inputs)
	if (locale === "es") return es_core_benefits_and_highlights_bu(inputs)
	if (locale === "fr") return fr_core_benefits_and_highlights_bu(inputs)
	if (locale === "de") return de_core_benefits_and_highlights_bu(inputs)
	if (locale === "ja") return ja_core_benefits_and_highlights_bu(inputs)
	if (locale === "zh") return zh_core_benefits_and_highlights_bu(inputs)
	if (locale === "ar") return ar_core_benefits_and_highlights_bu(inputs)
	if (locale === "id") return id_core_benefits_and_highlights_bu(inputs)
	if (locale === "it") return it_core_benefits_and_highlights_bu(inputs)
	if (locale === "ru") return ru_core_benefits_and_highlights_bu(inputs)
	if (locale === "pt") return pt_core_benefits_and_highlights_bu(inputs)
	return ko_core_benefits_and_highlights_bu(inputs)
});